/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationItem } from '@squiz/sds';
import {
  DATASTORE_BLUEPRINT_CLI,
  DATASTORE_BLUEPRINT_MARKETPLACE,
  DATASTORE_FEATURES_CAPABILITIES,
  DATASTORE_USER_TUTORIALS,
} from './Links.constants';
import {
  CONNECT_WORKSPACES,
  DATASTORE_LANDING,
  FORM_INSTANCES,
  FUNNELBACK_ADMIN_INSTANCES,
  MATRIX_INSTANCES,
} from './Screens.constants';

/**
 * All navigation items that make up general Advanced Forms screens.
 */
export const DXP_MENU_ADVANCED_FORMS_SCREENS: Array<NavigationItem> = [FORM_INSTANCES];

/**
 * All navigation items that make up general Content Management screens.
 */
export const DXP_MENU_CONTENT_MANAGEMENT_SCREENS: Array<NavigationItem> = [MATRIX_INSTANCES];

/**
 * All navigation items that make up general Data Services screens.
 */
export const DXP_MENU_DATA_SERVICES_SCREENS: Array<NavigationItem> = [
  DATASTORE_LANDING,
  DATASTORE_USER_TUTORIALS,
  DATASTORE_BLUEPRINT_CLI,
  DATASTORE_FEATURES_CAPABILITIES,
  DATASTORE_BLUEPRINT_MARKETPLACE,
];

/**
 * All navigation items that make up general Integrations screens.
 */
export const DXP_MENU_INTEGRATIONS_SCREENS: Array<NavigationItem> = [CONNECT_WORKSPACES];

/**
 * All navigation items that make up general Search screens.
 */
export const DXP_MENU_SEARCH_SCREENS: Array<NavigationItem> = [FUNNELBACK_ADMIN_INSTANCES];
